import { Body1, Button, Image, Link, Modal } from '@cian/ui-kit';
import * as React from 'react';

import { IAgentCardParticipation } from '../../types/agentCard';

import * as styles from './ParticipationMobile.css';

type TParticipationMobileProps = {
  participation: IAgentCardParticipation;
};

export const ParticipationMobile: React.FC<TParticipationMobileProps> = ({ participation }) => {
  const { title, description, iconUrl, infoUrl, infoTitle } = participation;

  const [isOpen, setIsOpen] = React.useState(false);

  const handleOpen = React.useCallback(() => setIsOpen(true), []);
  const handleClose = React.useCallback(() => setIsOpen(false), []);

  return (
    <>
      <div className={styles['trigger']} onClick={handleOpen} data-name="ParticipationMobile">
        <span className={styles['icon']}>
          <Image src={iconUrl} width={24} height={24} objectFit="contain" borderRadius={0} />
        </span>
        <Body1>{title}</Body1>
      </div>

      <Modal
        open={isOpen}
        onOpenChange={setIsOpen}
        size="S"
        footer={
          <Button size="L" fullWidth onClick={handleClose}>
            Закрыть
          </Button>
        }
      >
        <div className={styles['content']}>
          <Body1>{description}</Body1>
          <Link href={infoUrl} target="_blank" rel="noreferrer" fontSize="M" spacingSize="M">
            {infoTitle}
          </Link>
        </div>
      </Modal>
    </>
  );
};
